<div class="panel">
    <div class="panel__content no-padding">
        <mat-horizontal-stepper class="mat-stepper--disable-header" [linear]="true">
            <mat-step [stepControl]="stepOne">
                <form [formGroup]="stepOne">
                    <ng-template matStepLabel>Who is this template for?</ng-template>
                    <div class="stepper">
                        <div class="question">
                            <div class="question__text">Will this template be shared globally for all customers, or is it for a single customer?</div>
                            <mat-radio-group class="question__control" [(ngModel)]="selectAccess" formControlName="selectAccess" ngDefaultControl>
                                <mat-radio-button *ngIf="selectGlobalAccessAllowed" (click)="setCustomerRequired(false)" value="Global">Global</mat-radio-button>
                                <mat-radio-button (click)="setCustomerRequired(true)" value="Customer">Customer</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class="question" *ngIf="selectAccess == 'Customer'">
                            <div class="question__text">Select the customer this template is for</div>
                            <div class="input-container question__control">
                                <span class="label">Customer</span>
                                <select [(ngModel)]="selectCustomer" formControlName="selectCustomer">
                                    <option *ngFor="let customer of customerList" value="{{customer.Id}}">{{customer.Title}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="question">
                            <div class="question__text">What type of implement will this template be used for? </div>
                            <mat-radio-group class="question__control" [(ngModel)]="selectImplementType" formControlName="selectImplementType" ngDefaultControl>
                                <mat-radio-button (click)="loadGetComponentTypes()" value="GET">Ground Engaging Tools</mat-radio-button>
                                <mat-radio-button (click)="loadDumpBodyComponentTypes()" value="Dump Body">Dump Body</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class="stepper__buttons">
                            <button type="button" class="button button--primary margin-right-8" matStepperNext><i class="material-icons button__icon">arrow_forward</i><span class="button__text">Next</span></button>
                        </div>
                    </div>
                </form>
            </mat-step>
            <mat-step [stepControl]="stepTwo">
                <form [formGroup]="stepTwo">
                    <ng-template matStepLabel>Implement Details</ng-template>
                    <div class="stepper">
                        <div class="question">
                            <div class="question__text">Give this implement template a name</div>
                            <div class="input-container question__control">
                                <span class="label">Name</span>
                                <input class="no-grow" type="text" [(ngModel)]="implementName" formControlName="implementName" placeholder="eg. Large Bucket" />
                            </div>
                        </div>
                        <div class="question">
                            <div class="question__text">Which machine models is this type of implement used on?</div>
                            <input class="no-grow" type="text" placeholder="Filter list" (keyup)="onModelListFilterChange()" [(ngModel)]="modelListFilter" formControlName="modelListFilter" />

                            <mat-checkbox id="cbHideSelectedModels" (checked)="hideSelectedModels" (click)="toggleSelectedModels()">Hide Selected</mat-checkbox>
                            <mat-checkbox id="cbHideUnselectedModels" (checked)="hideUnselectedModels" (click)="toggleUnselectedModels()">Hide Unselected</mat-checkbox>
                                
                            <div class="question__control">
                                <div class="input-container">
                                    <mat-selection-list *ngIf="modelsLoaded" class="select-list--overflow" #modelListComponent style="width: 100%;">
                                        <ng-container *ngFor="let model of modelListFiltered">
                                            <mat-list-option *ngIf="selectionLogicForModels(model.Selected)" checkboxPosition="before" [selected]="model.Selected" 
                                                             [value]="model.Id" (click)="onModelListControlChanged(model.Id)">
                                                {{ model.Name }}
                                            </mat-list-option>
                                        </ng-container>
                                    </mat-selection-list>
                                </div>
                            </div>
                        </div>
                        <div class="question">
                            <div class="question__text">Which components belong on this implement template, and should be inspected?</div>
                            <input class="no-grow" (keyup)="onComponentTypeListFilterChange()" type="text" placeholder="Filter list" [(ngModel)]="componentTypesFilter" formControlName="componentTypesFilter" />

                            <mat-checkbox id="cbHideSelectedMPs" (checked)="hideSelectedMPs" (click)="toggleSelectedMPs()">Hide Selected</mat-checkbox>
                            <mat-checkbox id="cbHideUnselectedMPs" (checked)="hideUnselectedMPs" (click)="toggleUnselectedMPs()">Hide Unselected</mat-checkbox>

                            <div class="question__control">
                                <div class="input-container">
                                    <div class="select-list--overflow">
                                        <mat-selection-list class="" #componentTypeListId style="width: 100%;">
                                            <ng-container *ngFor="let componentType of componentTypeListFiltered">
                                                <mat-list-option *ngIf="selectionLogicForMPs(componentType.Selected)" [selected]="componentType.Selected" checkboxPosition="before" 
                                                                 [value]="componentType.Id" (click)="onComponentTypeListControlChanged(componentType.Id, componentType.Name)">
                                                    {{ componentType.Name }}
                                                </mat-list-option>
                                            </ng-container>
                                        </mat-selection-list>
                                        <div style="visibility: hidden; margin-top: 24px; " #scrollTarget>.</div>
                                    </div>
                                </div>
                                <div class="input-container">
                                    <span class="label">Add Measurement Point</span>
                                    <input type="text" style="margin-right: 16px!important;" (keyup.enter)="addNewComponent(scrollTarget)" placeholder="eg. Front Right Blade" [(ngModel)]="newComponentName" formControlName="newComponentName" />
                                    <a class="button" (click)="addNewComponent(scrollTarget)"><i class="material-icons button__icon">add</i><span class="button__text">Add</span></a>
                                </div>
                            </div>
                        </div>
                        <div class="stepper__buttons">
                            <button type="button" class="button margin-right-8" matStepperPrevious><i class="material-icons button__icon">arrow_back</i><span class="button__text">Back</span></button>
                            <button type="button" class="button button--primary" [class.loading]="savingSchematic" (click)="onSaveClick()"><i class="material-icons button__icon">check</i><span class="button__text">Save & Setup Schematics</span></button>
                        </div>
                    </div>
                </form>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Schematic Setup</ng-template>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
</div>